import Api from "./Api";

const endpoint = "/proben_stammdaten";
export default {
    get(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(endpoint, usedParams);
    },
    getEinzelproben(id) {
        return Api.fetchData(endpoint + "/" + id + "/einzelproben");
    },
    post(data) {
        return Api.postData(endpoint, data);
    },
    put(id, data) {
        return Api.putData(endpoint + "/" + id, data);
    },
    putEinzelprobe(id, data) {
        return Api.putData(endpoint + "/" + id + "/einzelproben", data);
    },
    delete(id) {
        return Api.deleteData(endpoint + "/" + id);
    }
};
